import { authenticatedRequest } from './apiClient';
import { ApiZone, ApiZoneCreate, ApiZoneUpdate } from '../types/api';

export async function getZones(): Promise<ApiZone[]> {
  return authenticatedRequest<ApiZone[]>('/zones');
}

export async function getZone(zoneId: string): Promise<ApiZone> {
  return authenticatedRequest<ApiZone>(`/zones/${zoneId}`);
}

export async function createZone(zone: ApiZoneCreate): Promise<ApiZone> {
  return authenticatedRequest<ApiZone>('/zones', {
    method: 'POST',
    body: JSON.stringify(zone),
  });
}

export async function updateZone(
  zoneId: string,
  updates: ApiZoneUpdate
): Promise<ApiZone> {
  return authenticatedRequest<ApiZone>(`/zones/${zoneId}`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}

export async function deleteZone(zoneId: string): Promise<void> {
  await authenticatedRequest<void>(`/zones/${zoneId}`, {
    method: 'DELETE',
  });
}
